module.exports = __webpack_public_path__ + "img/871a54a71e7af885687ba75c73e07b4e.png";